import { __assign, __rest } from "tslib";
import { ricosBICallbacks } from './ricosBICallbacks';
export function biStrategy(appDefId, metaSiteId, wixRicosVersion, biSettings, _experiments // eslint-disable-line
) {
    var biCallbacks = biSettings.biCallbacks, settingsPostId = biSettings.postId, settingsContentId = biSettings.contentId, rest = __rest(biSettings, ["biCallbacks", "postId", "contentId"]);
    var logger = ricosBICallbacks(__assign(__assign({}, rest), { contentId: settingsPostId || settingsContentId || '', appDefId: appDefId, metaSiteId: metaSiteId, wixRicosVersion: wixRicosVersion }));
    return {
        helpers: {
            onPluginAdd: function (pluginId, entryPoint, version) {
                var _a;
                logger.onPluginAdd(pluginId, entryPoint, version);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginAdd) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, pluginId, entryPoint, version);
            },
            onPluginAddStep: function (args) {
                var _a;
                logger.onPluginAddStep(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginAddStep) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onPluginAddSuccess: function (pluginId, entryPoint, params, version) {
                var _a;
                logger.onPluginAddSuccess(pluginId, entryPoint, params, version);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginAddSuccess) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, pluginId, entryPoint, params, version);
            },
            onPluginDelete: function (args) {
                var _a;
                logger.onPluginDelete(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginDelete) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onPublish: function (contentId, pluginsCount, pluginsDetails, version) {
                var _a;
                var appliedContentId = contentId || settingsPostId || settingsContentId;
                logger.onPublish(appliedContentId, pluginsCount, pluginsDetails, version);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPublish) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, appliedContentId, pluginsCount, pluginsDetails, version);
            },
            onMenuLoad: function (args) {
                var _a;
                logger.onMenuLoad(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onMenuLoad) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onPluginModalOpened: function (args) {
                var _a;
                logger.onPluginModalOpened(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginModalOpened) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onViewerAction: function (pluginId, actionName, value) {
                var _a;
                logger.onViewerAction(pluginId, actionName, value);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onViewerAction) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, pluginId, actionName, value);
            },
            onViewerLoaded: function (args) {
                var _a;
                logger.onViewerLoaded(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onViewerLoaded) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onOpenEditorSuccess: function (version, toolbarType) {
                var _a;
                logger.onOpenEditorSuccess(version, toolbarType);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onOpenEditorSuccess) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, version, toolbarType);
            },
            onContentEdited: function (args) {
                var _a;
                logger.onContentEdited(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onContentEdited) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onInlineToolbarOpen: function (args) {
                var _a;
                logger.onInlineToolbarOpen(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onInlineToolbarOpen) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onToolbarButtonClick: function (args) {
                var _a;
                logger.onToolbarButtonClick(args);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onToolbarButtonClick) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, args);
            },
            onMediaUploadStart: function (correlationId, pluginId, fileSize, mediaType, version) {
                var _a;
                logger.onMediaUploadStart(correlationId, pluginId, fileSize, mediaType, version);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onMediaUploadStart) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, correlationId, pluginId, fileSize, mediaType, version);
            },
            onMediaUploadEnd: function (correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version) {
                var _a;
                logger.onMediaUploadEnd(correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onMediaUploadEnd) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version);
            },
            onPluginAction: function (eventName, params) {
                var _a;
                logger.onPluginAction(eventName, params);
                (_a = biCallbacks === null || biCallbacks === void 0 ? void 0 : biCallbacks.onPluginAction) === null || _a === void 0 ? void 0 : _a.call(biCallbacks, eventName, params);
            },
        },
    };
}
//# sourceMappingURL=biStrategy.js.map